export const StatisticTables = {
	bookings_created_by_weekday: {
		identifier: 'bookings_created_by_weekday',
		headers: [ "day","bookings","percentage" ],
		details: 'bookings_created_by_month',
		depth: 0
	},
	bookings_created_by_month: {
		identifier: 'bookings_created_by_month',
		headers: [ "day","bookings" ],
		details: 'bookings_created_by_day',
		depth: 1
	},
	bookings_created_by_day: {
		identifier: 'bookings_created_by_day',
		headers: [ "day","bookings" ],
		depth: 2
	},
	
	bookings_scheduled_by_weekday: {
		identifier: 'bookings_scheduled_by_weekday',
		headers: [ "day","bookings","percentage" ],
		details: 'bookings_scheduled_by_month',
		depth: 0
	},
	bookings_scheduled_by_month: {
		identifier: 'bookings_scheduled_by_month',
		headers: [ "day","bookings"],
		details: 'bookings_scheduled_by_day',
		depth: 1
	},
	bookings_scheduled_by_day: {
		identifier: 'bookings_scheduled_by_day',
		headers: [ "day","bookings"],
		depth: 2
	},
	
	chart_employee_bookings_week: {
		identifier: 'chart_employee_bookings_week',
		headers: [ "year","week","name", 'amount' ],
		details: 'chart_employee_bookings_week',
		depth: 0
	},
	
	chart_checkin_time: {
		identifier: 'chart_checkin_time',
		headers: [ "time", 'amount' ],
		details: 'chart_checkin_time',
		depth: 0
	},
	
	chart_book_time: {
		identifier: 'chart_book_time',
		headers: [ "time", 'amount' ],
		details: 'chart_book_time',
		depth: 0
	}
}
